export const ES: Record<string, string> = {
  "Home": "Inicio",
  "Resource Selected": "Recurso Seleccionado",
  "Resources List": "Lista de Recursos",
  "List": "Lista",
  "Resources": "Recursos",
  "Find Colleague": "Buscar Colega",
  "Settings": "Ajustes",
  "Floor Plan": "Plano de Planta",
  "Locations": "Ubicaciones",
  "Categories": "Categorías",
  "Search resource name...": "Buscar nombre del recurso...",
  "Calendar": "Calendario",
  "View Details": "Ver Detalles",
  "Add to My Favorites": "Agregar a Mis Favoritos",
  "Remove": "Eliminar",
  "Resource calendar": "Calendario de Recursos",
  "Today": "Hoy",
  "Previous month": "Mes Anterior",
  "Next month": "Próximo Mes",
  "Previous year": "Año Anterior",
  "Next year": "Próximo Año",
  "Close": "Cerrar",
  "Field is required.": "Campo obligatorio.",
  "Invalid date format.": "Formato de fecha inválido.",
  "S": "Dom",
  "M": "Lun",
  "T": "Mar",
  "W": "Mié",
  "F": "Vie",
  "January": "Enero",
  "February": "Febrero",
  "March": "Marzo",
  "April": "Abril",
  "May": "Mayo",
  "June": "Junio",
  "July": "Julio",
  "August": "Agosto",
  "September": "Septiembre",
  "October": "Octubre",
  "November": "Noviembre",
  "December": "Diciembre",
  "Jan": "Ene",
  "Feb": "Feb",
  "Mar": "Mar",
  "Apr": "Abr",
  "Jun": "Jun",
  "Jul": "Jul",
  "Aug": "Ago",
  "Sep": "Sep",
  "Oct": "Oct",
  "Nov": "Nov",
  "Dec": "Dic",
  "st": "º",
  "nd": "º",
  "rd": "º",
  "th": "º",
  "Sunday": "Domingo",
  "Monday": "Lunes",
  "Tuesday": "Martes",
  "Wednesday": "Miércoles",
  "Thursday": "Jueves",
  "Friday": "Viernes",
  "Saturday": "Sábado",
  "Sun": "Dom",
  "Mon": "Lun",
  "Tue": "Mar",
  "Wed": "Mié",
  "Thu": "Jue",
  "Fri": "Vie",
  "Sat": "Sáb",
  "Su": "Dom",
  "Mo": "Lun",
  "Tu": "Mar",
  "We": "Mié",
  "Th": "Jue",
  "Fr": "Vie",
  "Sa": "Sáb",
  "PM": "PM",
  "AM": "AM",
  "You cannot book this resource because your meeting request conflicts with the resource's booking policies.":
    "No puedes reservar este recurso porque tu solicitud de reunión entra en conflicto con las políticas de reserva del recurso.",
  "You need permissions to interact with this resource.":
    "Necesitas permisos para interactuar con este recurso.",
  "Reason": "Motivo",
  "The resource cannot be booked {{day}} days in advanced.":
    "El recurso no se puede reservar con {{day}} días de antelación.",
  "The end date of a recurring meeting cannot be more than {{day}} days from today.":
    "La fecha de finalización de una reunión recurrente no puede ser más de {{day}} días a partir de hoy.",
  "Meeting duration cannot be longer than {{time}} minutes long.":
    "La duración de la reunión no puede ser más larga de {{time}} minutos.",
  "Meeting duration cannot be shorter than {{time}} minutes long.":
    "La duración de la reunión no puede ser más corta de {{time}} minutos.",
  "Booking policy": "Política de Reserva",
  "Available": "Disponible",
  "Selected": "Seleccionado",
  "Booked": "Reservado",
  "Closed": "Cerrado",
  "Filter Options": "Opciones de Filtro",
  "{{resource}} is deleted": "{{resource}} ha sido eliminado.",
  "This resource can be booked but any occurrences with conflicts the resource will not be booked.":
    "Este recurso se puede reservar, pero no se reservarán las ocurrencias que entren en conflicto con el recurso.",
  "This resource can be booked in advance for a maximum of {{day}} days, any occurrences beyond that limit will not be booked":
    "Este recurso se puede reservar con antelación por un máximo de {{day}} días, no se reservarán las ocurrencias más allá de ese límite.",
  "This resource can be booked, but the meeting duration must be at least {{time}} minutes.":
    "Este recurso se puede reservar, pero la duración de la reunión debe ser de al menos {{time}} minutos.",
  "This resource can be booked, but the meeting duration must not exceed {{time}} minutes.":
    "Este recurso se puede reservar, pero la duración de la reunión no debe exceder {{time}} minutos.",
  "Booking this resource requires approval by the resource's delegate. Your request will be forwarded, pending approval.":
    "Reservar este recurso requiere aprobación por parte del delegado del recurso. Tu solicitud será enviada, pendiente de aprobación.",
  "Resource Name": "Nombre del Recurso",
  "Description": "Descripción",
  "Resource Mail": "Correo del Recurso",
  "Location": "Ubicación",
  "Capacity": "Capacidad",
  "Language": "Idioma",
  "Select an language": "Seleccionar un idioma",
  "Date/Time Format": "Formato de Fecha/Hora",
  "First day of the week": "Primer día de la semana",
  "Please select a first day": "Por favor selecciona un primer día",
  "Please select a time format": "Por favor selecciona un formato de hora",
  "Date Format": "Formato de Fecha",
  "Please select a date format": "Por favor selecciona un formato de fecha",
  "Date Separator": "Separador de Fecha",
  "Please select a date separator": "Por favor selecciona un separador de fecha",
  "Apply": "Aplicar",
  "Default Location": "Ubicación por Defecto",
  "Clear": "Limpiar",
  "Help": "Ayuda",
  "Unavailable": "No disponible",
      "No data available": "No hay datos disponibles",
      "More": "Más",
  "Available Floor Plans": "Planos de Planta Disponibles",
  "Default Categories": "Categorías por Defecto",
  "List more Resources": "Listar más Recursos",
  "Attendees": "Asistentes",
  "Click on Further information to visit our support site": "Haz clic en Más información para visitar nuestro sitio de soporte",
  "New Order": "Nueva Orden",
  "Save default categories successfully": "Guardar categorías predeterminadas con éxito",
      "Save config date/time successfully": "Guardar configuración de fecha/hora con éxito",
      "Save language successfully": "Guardar idioma con éxito",
      "Save default location successfully": "Guardar ubicación predeterminada con éxito",
      "And": "Y",
  "Or": "O",
  "Available occurrences of the series": "Ocurrencias disponibles de la serie",
  "Conflicting Occurrences": "Ocurrencias en conflicto",
  "Availability": "Disponibilidad",
  "Time Format": "Formato de tiempo",
  "You do not have permission to book this resource.": "No tiene permiso para reservar este recurso.",
"This resource does not allow booking of recurring meetings.": "Este recurso no permite la reserva de reuniones recurrentes.",
"You cannot book this resource.": "No puede reservar este recurso."
};
